export const JUTE_CONVERSION_LIST = "jute_conversion_list";
export const JUTE_CONVERSION_LIST_SUCCESSFULL = "jute_conversion_list_successfull";
export const JUTE_GET_STOCK_DETAILS_BY_GODOWN_NUMBER = "jute_get_stock_details_by_godown_number";
export const JUTE_GET_STOCK_DETAILS_BY_GODOWN_NUMBER_SCCESSFULL = "jute_get_stock_details_by_godown_number_successfull";
// export const JUTE_GATE_ENTRY_LINE_ITEMS = "jute_gate_entry_line_items";
// export const JUTE_GATE_ENTRY_CREATE = "jute_gate_entry_create";
// export const JUTE_GATE_ENTRY_VIEW_BY_ID = "jute_gate_entry_view_by_id";
// export const JUTE_GATE_ENTRY_VIEW_BY_ID_SCCESSFULL = "jute_gate_entry_view_by_id_successfull";
